import React from 'react';
import { Elements } from 'react-stripe-elements';
import InjectedCheckoutForm from './CheckoutForm';
import ChargeCard from './ChargeCard';
// import './profile.css';

const NegativeBalance = props => (
  <div className="payments__stripe--container">
    <ChargeCard
      {...props}
    />
    {/* <Elements>
      <InjectedCheckoutForm {...props} />
    </Elements> */}
  </div>
);

export default NegativeBalance;



// WEBPACK FOOTER //
// ./src/components/NewPayments/NegativeBalance.js